import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  Select,
  TextField,
} from '@material-ui/core';
import React, { useEffect } from 'react';
import { AiFillEdit } from 'react-icons/ai';
import { useNavigate, useParams } from 'react-router';
import { useGrades } from '../grades/Grades';
import { useSeries } from '../series/Series';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
    maxWidth: '100%',
  },
  TableContainer: {
    maxWidth: '70%',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '22%',
  },
  input: {
    marginTop: '10px',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
  formButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: '50px',
  },
  formControl: {
    marginTop: theme.spacing(2),
  },
  coverImagePicker: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: '#555',
    fontFamily: 'Roboto',
    padding: '10px',
    backgroundColor: '#f5f5f5',
    cursor: 'pointer',
    borderRadius: '5px',
  },
}));

function useBooks() {
  const [books, setBooks] = React.useState([]);
  React.useEffect(() => {
    fetch('https://api.edicionesmilenio.com/api/books')
      .then((response) => response.json())
      .then((data) => {
        setBooks(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  return { books, setBooks };
}

export default function UpdateBook() {
  const classes = useStyles();
  const { books, setBooks } = useBooks();
  const { series } = useSeries();
  const { grades } = useGrades();
  const [name, setName] = React.useState('');
  const [serie, setSerie] = React.useState('');
  const [grade, setGrade] = React.useState('');
  const [coverImage, setCoverImage] = React.useState('');
  const filePickerRef = React.useRef(null);
  const coverImagePreviewRef = React.useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/books/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data?.data) {
          setName(data?.data?.name);
          setSerie(data?.data?.serie?._id);
          setGrade(data?.data?.grade?._id);
          setCoverImage(data?.data?.coverImage);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleUpdate = async () => {
    try {
      let formData = new FormData();
      formData.append('name', name);
      formData.append('serie', serie);
      formData.append('grade', grade);
      formData.append('coverImage', coverImage);

      let response = await fetch(
        `https://api.edicionesmilenio.com/api/books/${id}`,
        {
          method: 'PUT',
          body: formData,
        }
      );
      let data = await response.json();
      if (data.success === true) {
        navigate('/admin/books', { replace: true });
      } else {
        console.error(data.message);
        window.alert('Error al actualizar el libro, intente de nuevo');
      }
    } catch (err) {
      console.error(err);
      window.alert('Error al actualizar el libro, intente de nuevo');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, mediante este formulario usted podrá actualizar
        los libros de la plataforma.
      </p>
      <TextField
        className={classes.input}
        id="outlined-basic"
        label="Nombre el libro"
        variant="outlined"
        value={name || ''}
        onChange={(e) => setName(e.target.value)}
      />
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="select-serie">Serie del libro</InputLabel>

        <Select
          onChange={(e) => setSerie(e.target.value)}
          value={serie || ''}
          id="select-serie"
          native
        >
          <option value="" disabled>
            <em>Seleccione una serie</em>
          </option>
          {series.map((serie) => (
            <option value={serie._id}>{serie.name}</option>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="select-grade">Grado del libro</InputLabel>

        <Select
          onChange={(e) => setGrade(e.target.value)}
          value={grade || ''}
          id="select-grade"
          native
        >
          <option value="" disabled>
            <em>Seleccione un grado</em>
          </option>
          {grades.map((grade) => (
            <option value={grade._id}>{grade.name}</option>
          ))}
        </Select>
      </FormControl>
      <div
        onClick={() => {
          setCoverImage(null);
          filePickerRef.current.click();
        }}
        className={classes.coverImagePicker}
      >
        {coverImage && (
          <img
            style={{ width: '50px', height: '50px', marginRight: '20px' }}
            ref={coverImagePreviewRef}
            src={
              typeof coverImage === 'string'
                ? 'https://api.edicionesmilenio.com/' + coverImage
                : URL.createObjectURL(coverImage)
            }
            alt="preview"
          />
        )}
        <input
          ref={filePickerRef}
          style={{ display: 'none' }}
          type="file"
          name="coverImage"
          onChange={(e) => {
            setCoverImage(e.target.files[0]);
            const reader = new FileReader();
            reader.onload = (e) => {
              coverImagePreviewRef.current.src = e.target.result;
            };
            reader.readAsDataURL(e.target.files[0]);
          }}
          accept="coverImage/*"
        />
        {coverImage && <p>{coverImage?.name}</p>}
        {!coverImage && (
          <p style={{ alignSelf: 'center', justifySelf: 'center' }}>
            Seleccione una imagen para el libro
          </p>
        )}
      </div>
      <Button
        onClick={() => {
          setName('');
          setSerie('');
          setGrade('');
          setCoverImage('');
        }}
      >
        Limpiar
      </Button>
      <div className={classes.formButtonsContainer}>
        <Button variant="contained" onClick={handleUpdate}>
          <AiFillEdit size={15} />
          Actualizar
        </Button>
      </div>
    </div>
  );
}
